export const ITEM_NOT_FOUND_INDEX = -1;

export const DEFAULT_ENVIRONMENT = 'prod';

export const DEFAULT_DEBOUNCE_DELAY = 300;
